// // import { NavLink } from "react-router-dom";
// // import { useEffect, useState } from "react";
// // import API from "../../services/api";
// // import menuByRole from "../../config/menuConfig";
// // import logo from "../../assets/logo.png";
// // import "../../styles/sidebar.css";


// // function Sidebar({ collapsed }) {
// // const rawRole = localStorage.getItem("role")?.toLowerCase();

// // const [telesales, setTelesales] = useState([]);
// // const [salesExec, setSalesExec] = useState([]);

// // const [openTele, setOpenTele] = useState(false);
// // const [openSales, setOpenSales] = useState(false);
  

// // // 🔥 role mapping fix
// // const roleMap = {
// //   "sales executive": "salesexec",
// //   "telesales": "telesales",
// //   "boss": "boss",
// //   "sales manager": "manager",
// //   "it manager": "itmanager"
// // };

// // const role = roleMap[rawRole] || rawRole;

// // const menu = menuByRole[role] || [];

// //   // 🔥 Only for boss → fetch employees
// //   useEffect(() => {
// //     if (role === "boss") {
// //       const fetchUsers = async () => {
// //         try {
// //           const res = await API.get("/users");

// //           setTelesales(res.data.filter(u => u.role_id === 4));
// //           setSalesExec(res.data.filter(u => u.role_id === 3));

// //         } catch (err) {
// //           console.log(err);
// //         }
// //       };

// //       fetchUsers();
// //     }
// //   }, [role]);

// //   return (
// // <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
// //       {/* LOGO */}
// //       <div className="logo">
// //         <img src={logo} alt="logo" />
// //       </div>

// //       <ul>

// //         {/* 🔥 BOSS VIEW */}
// //         {role === "boss" ? (
// //           <>

// //             {/* 🔥 Menu items */}
// //             {menu.map((item, index) => (
// //               <li key={index}>
// //                 <NavLink to={item.path}>
// //                   {item.icon}
// //                   {!collapsed && <span>{item.name}</span>}
// //                 </NavLink>
// //               </li>
// //             ))}

// //             {/* 🔻 TELESALES DROPDOWN */}
// //             <li className="dropdown-parent">
// //   <div
// //     className="dropdown-toggle"
// //     onClick={() => setOpenTele(!openTele)}
// //   >
// //     📞 {!collapsed && <span>Telesales ▼</span>}
// //   </div>

// //   {openTele && (
// //     <ul className="dropdown-menu">
// //       {telesales.map(emp => (
// //         <li key={emp.id}>
// //           <NavLink to={`/telesales/${emp.id}`}>
// //             {!collapsed && <span>{emp.name}</span>}
// //           </NavLink>
// //         </li>
// //       ))}
// //     </ul>
// //   )}
// // </li>
// //             {/* 🔻 SALES EXEC DROPDOWN */}
// //             <li className="dropdown-parent">
// //               <div
// //                 className="dropdown-toggle"
// //                 onClick={() => setOpenSales(!openSales)}
// //               >
// //                 👥 {!collapsed && <span>Sales Executive ▼</span>}
// //               </div>

// //               {openSales && (
// //                 <ul className="dropdown-menu">
// //                   {salesExec.map(emp => (
// //                     <li key={emp.id}>
// //                       <NavLink to={`/salesexec/${emp.id}`}>
// //                         {!collapsed && <span>{emp.name}</span>}
// //                       </NavLink>
// //                     </li>
// //                   ))}
// //                 </ul>
// //               )}
// //             </li>

// //           </>
// //         ) : (

// //           /* 🔥 TELESALES / SALES USER VIEW */
// //           menu.map((item, index) => (
// //             <li key={index}>
// //               <NavLink to={item.path}>
// //                 {item.icon}
// //                 {!collapsed && <span>{item.name}</span>}
// //               </NavLink>
// //             </li>
// //           ))

// //         )}

// //       </ul>

// //     </div>
// //   );
// // }

// // export default Sidebar;

// import { NavLink } from "react-router-dom";
// import { useEffect, useState } from "react";
// import API from "../../services/api";
// import menuByRole from "../../config/menuConfig";
// import logo from "../../assets/logo.png";
// import "../../styles/sidebar.css";

// function Sidebar({ collapsed }) {

//   const rawRole = localStorage.getItem("role")?.toLowerCase();

//   const [telesales, setTelesales] = useState([]);
//   const [salesExec, setSalesExec] = useState([]);

//   const [openTele, setOpenTele] = useState(false);
//   const [openSales, setOpenSales] = useState(false);

//   // 🔥 role mapping
//   const roleMap = {
//     "sales executive": "salesexec",
//     "telesales": "telesales",
//     "boss": "boss",
//     "it manager": "itmanager"
//   };

//   const role = roleMap[rawRole] || rawRole;
//   const menu = menuByRole[role] || [];

//   // 🔥 Fetch users (boss only)
//   useEffect(() => {
//     if (role === "boss") {
//       const fetchUsers = async () => {
//         try {
//           const res = await API.get("/users");

//          const users = res.data.users || res.data;
// setTelesales(
//   users.filter(u => Number(u.role_id) === 4)
// );

// setSalesExec(
//   users.filter(u => Number(u.role_id) === 3)
// );

//         } catch (err) {
//           console.log(err);
//         }
//       };

//       fetchUsers();
//     }
//   }, [role]);

//   return (
//     <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>

//       {/* LOGO */}
//       <div className="logo">
//         <img src={logo} alt="logo" />
//       </div>

//       <ul>

//         {/* 👑 BOSS VIEW */}
//         {role === "boss" ? (
//           <>
//             {/* Main Menu */}
//             {menu.map((item, index) => (
//               <li key={index}>
//                 <NavLink to={item.path}>
//                   {item.icon}
//                   {!collapsed && <span>{item.name}</span>}
//                 </NavLink>
//               </li>
//             ))}

//             {/* 🔻 TELESALES DROPDOWN */}
//             {/* 🔻 TELESALES */}
// <li>
//   <div onClick={() => setOpenTele(!openTele)}>
//     📞 Telesales {openTele ? "▲" : "▼"}
//   </div>

//   {openTele && (
//     <ul>
//       {telesales.map(emp => (
//         <li key={emp.id}>
//           {emp.name}
//         </li>
//       ))}
//     </ul>
//   )}
// </li>

// {/* 🔻 SALES EXEC */}
// <li>
//   <div onClick={() => setOpenSales(!openSales)}>
//     👥 Sales Exec {openSales ? "▲" : "▼"}
//   </div>

//   {openSales && (
//     <ul>
//       {salesExec.map(emp => (
//         <li key={emp.id}>
//           {emp.name}
//         </li>
//       ))}
//     </ul>
//   )}
// </li>

//           </>
//         ) : (
//           /* 👤 NORMAL USERS */
//           menu.map((item, index) => (
//             <li key={index}>
//               <NavLink to={item.path}>
//                 {item.icon}
//                 {!collapsed && <span>{item.name}</span>}
//               </NavLink>
//             </li>
//           ))
//         )}

//       </ul>

//     </div>
//   );
// }

// export default Sidebar;

import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../../services/api";
import menuByRole from "../../config/menuConfig";
import logo from "../../assets/logo.png";
import "../../styles/sidebar.css";

function Sidebar({ collapsed }) {

  const rawRole = localStorage.getItem("role")?.toLowerCase();

  const [telesales, setTelesales] = useState([]);
  const [salesExec, setSalesExec] = useState([]);

  const [openTele, setOpenTele] = useState(false);
  const [openSales, setOpenSales] = useState(false);

  // 🔥 role mapping
  const roleMap = {
    "sales executive": "salesexec",
    "telesales": "telesales",
    "boss": "boss",
    "it manager": "itmanager",
    "sales manager": "manager"
  };

  const role = roleMap[rawRole] || rawRole;
  const menu = menuByRole[role] || [];

  // 🔥 Fetch users (boss only)
  useEffect(() => {
    if (role === "boss") {
      const fetchUsers = async () => {
        try {
          const res = await API.get("/users");

          // ✅ SAFE DATA HANDLING
          const users = Array.isArray(res.data)
            ? res.data
            : res.data.users || [];
            console.table(users);
            setTelesales(users.filter(u => Number(u.role_id) === 4));
setSalesExec(users.filter(u => Number(u.role_id) === 3));

          // console.log("USERS:", users);

          // ✅ FILTER BY ROLE_ID
      
        } catch (err) {
          console.log(err);
        }
      };

      fetchUsers();
    }
  }, [role]);

  return (
   <div className={`sidebar ${collapsed ? "collapsed" : ""} ${!collapsed ? "open" : ""}`}>

      {/* LOGO */}
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>

      <ul>

        {/* 👑 BOSS VIEW */}
        {role === "boss" ? (
          <>
            {/* Main Menu */}
            {menu.map((item, index) => (
              <li key={index}>
                <NavLink to={item.path}>
                  {item.icon}
                  {!collapsed && <span>{item.name}</span>}
                </NavLink>
              </li>
            ))}

            {/* 🔻 TELESALES */}
            <li>
              <div onClick={() => setOpenTele(!openTele)}>
                📞 {!collapsed && (
                  <span>Telesales {openTele ? "▲" : "▼"}</span>
                )}
              </div>

              {openTele && (
                <ul>
                  {telesales.length > 0 ? (
                    telesales.map(emp => (
                      <li key={emp.id}>
                        <NavLink to={`/boss/telesales/${emp.id}`}>
                          {emp.name}
                        </NavLink>
                      </li>
                    ))
                  ) : (
                    <li>No Telesales Found</li>
                  )}
                </ul>
              )}
            </li>

            {/* 🔻 SALES EXEC */}
            <li>
              <div onClick={() => setOpenSales(!openSales)}>
                👥 {!collapsed && (
                  <span>Sales Exec {openSales ? "▲" : "▼"}</span>
                )}
              </div>

              {openSales && (
                <ul>
                  {salesExec.length > 0 ? (
                    salesExec.map(emp => (
                      <li key={emp.id}>
                        <NavLink to={`/boss/salesexec/${emp.id}`}>
                           {emp.name}
                        </NavLink>
                      </li>
                    ))
                  ) : (
                    <li>No Sales Exec Found</li>
                  )}
                </ul>
              )}
            </li>

          </>
        ) : (
          /* 👤 NORMAL USERS */
          menu.map((item, index) => (
            <li key={index}>
              <NavLink to={item.path}>
                {item.icon}
                {!collapsed && <span>{item.name}</span>}
              </NavLink>
            </li>
          ))
        )}

      </ul>

    </div>
  );
}

export default Sidebar;